var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHash2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.55228 2 9 2.44772 9 3V7H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H17V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V17H9V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21V17H4C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15H7V9H4C3.44772 9 3 8.55228 3 8C3 7.44772 3.44772 7 4 7H7V3C7 2.44772 7.44772 2 8 2ZM15 15V9H9V15H15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHash2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hash2.96f1f3b047afbcca2542fa5a038cc3f6.svg";